export var now = function () {
    return Date.now ? Date.now() : +(new Date());
};



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/moment/now.js
// module id = 989
// module chunks = 111